import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalc, IIcmsClassificacao, ITags, newITags } from "../../../model";
import { AppStore } from "../../../stores/AppStore";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { v4 as uuidv4 } from 'uuid';
import { Alignment, Button, Classes, FormGroup, HTMLSelect, InputGroup, Popover } from "@blueprintjs/core";
import { TagsSelect, filterTags, renderTags } from "./TagsSelect";
import { TaskInformation, TaskInformationBloco, TaskList, Title, sorted_tags_ctes, sorted_tags_nfces, sorted_tags_nfes, sorted_tags_nfses } from "./RelatorioData";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import { RelatorioStore } from "../../../stores/relatorio/RelatorioStore";
import { MonthPicker } from "../../utils/MonthPicker";
import moment from "moment";
import IntlCurrencyInput from "react-intl-currency-input";
import { LookupStore } from "../../../stores/LookupStore";
import { CalcRSStore } from "../../../stores/calculo-rs/CalcRSStore";
import { CalcStore } from "../../../stores/calculo/CalcStore";
import { IcmsClassificacaoSelect, filterIcmsClassificacao, renderIcmsClassificacao } from "../../utils/IcmsClassificacaoSelect";
import { NotasStore } from "../../../stores/notas/NotasStore";

const ScreenSizeDetector = require('screen-size-detector');
const screen = new ScreenSizeDetector();

interface State {
  items: any
}

@observer
export class RelatorioFiltro extends React.Component<{}, State> {

  obs = observable({
    selectedTag: newITags() as ITags,
    texto: "" as string,
    op: "" as string,
    nome_relatorio: "" as string,
    sorted_tags: sorted_tags_nfes as any,
    select_date: null as Date,
    value: 0 as number,
    isBoolean: "" as string,
    icmsClassFilter: null as IIcmsClassificacao,
    calcFilter: "" as string,
    calcs: [] as any
  })

  constructor(props: any) {
    super(props);
    AppStore.setTitle("Filtro");

    if (RelatorioStore.obs.selectedEmpresa.cnpj == "") {
      AppStore.setLocation("/relatorios");
    }

    this.state = { items: [] }

    if (RelatorioStore.obs.select_relatorio.filtro.length > 0) {

      this.state = { items: RelatorioStore.obs.select_relatorio.filtro }

    }

    if (RelatorioStore.obs.modelo == "CT-E") {
      this.obs.sorted_tags = sorted_tags_ctes
    }
    if (RelatorioStore.obs.modelo == "NFC-E") {
      this.obs.sorted_tags = sorted_tags_nfces
    }
    if (RelatorioStore.obs.modelo == "NFS-E") {
      this.obs.sorted_tags = sorted_tags_nfses
    }

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  async componentDidMount() {

    if (RelatorioStore.obs.selectedEmpresa.uf == "RS") {
      await CalcRSStore.load();
      this.obs.calcs = CalcRSStore.obs.calcs

    } else {
      await CalcStore.load();
      this.obs.calcs = CalcStore.obs.calcs
    }

  }
  onDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(this.state.items);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    this.setState({
      items
    });
  }

  async handleSolicitar() {

    let params = {
      modelo: RelatorioStore.obs.modelo,
      tipo: RelatorioStore.obs.tipo,
      cnpj: RelatorioStore.obs.selectedEmpresa.cnpj,
      razao_social: RelatorioStore.obs.selectedEmpresa.razao_social,
      filtro: this.state.items,
      columns: RelatorioStore.obs.columns,
      date_start: RelatorioStore.obs.date_start,
      date_end: RelatorioStore.obs.date_end,
      format: NotasStore.obs.total_notas > 60000 ? "csv" : "xlsx"
    }

    let resp = await RelatorioStore.handleSolicitarRelatorio(params)

    if (resp) window.location.href = "/relatorios"

  }

  handleSaveRelatorio() {
    if (this.obs.nome_relatorio == "") {
      toast.warning('Preecnher o nome do Relatório.', {});
      return
    }
    RelatorioStore.obs.relatorio.filtro = this.state.items
    RelatorioStore.obs.relatorio.nome = this.obs.nome_relatorio
    RelatorioStore.obs.relatorio.modelo = RelatorioStore.obs.modelo

    RelatorioStore.handleSaveRelatorio(RelatorioStore.obs.relatorio)
  }

  handleCancel() {
    window.location.href = "/relatorios"
  }
  handleDelete(id) {
    let items = this.state.items.slice().filter((item) => item.id !== id);
    this.setState({ items });
  }

  handleAddItem() {
    if (this.obs.selectedTag.name == "") {
      toast.warning('Você precisa selecionar um Filtro.', {});
      return
    }
    if (this.obs.op == "") {
      toast.warning('Você precisa selecionar uma Operação.', {});
      return
    }
    if (this.obs.texto == "") {
      toast.warning('Digite um Texto.', {});
      return
    }

    let id = uuidv4()

    let valores = [...this.state.items, {
      "id": id,
      "if": this.obs.selectedTag.xml,
      "name": this.obs.selectedTag.name,
      "op": this.obs.op,
      "texto": this.obs.texto
    }]

    this.setState({ items: valores }, () => {
      this.obs.selectedTag = newITags()
      this.obs.op = ""
      this.obs.texto = ""
      this.obs.select_date = null
      this.obs.value = 0
      this.obs.isBoolean = ""
    });
  }

  handleDateChange(val) {
    var string = val?.toString();

    this.obs.texto = moment(string).format("YYYY-MM-DD")
    this.obs.select_date = val
  }

  handleSelectTag(e) {
    this.obs.op = ""
    this.obs.texto = ""
    this.obs.select_date = null
    this.obs.value = 0
    this.obs.isBoolean = ""
    this.obs.icmsClassFilter = null
    this.obs.calcFilter = ""

    this.obs.selectedTag = e
  }

  handleSelectBoolean(e) {
    this.obs.texto = e
    this.obs.isBoolean = e
  }

  handleSelectClass(item) {
    this.obs.icmsClassFilter = item
    this.obs.texto = item.nome
  }

  handleSelectCalc(item) {
    this.obs.calcFilter = item
    this.obs.texto = item
  }

  render() {
    let selectText = this.obs.selectedTag.tag != "" ? `${this.obs.selectedTag.name.substring(0, 38)}` : "Selecione";

    const currencyConfig = {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          },
        },
      },
    };

    const hanldeRendimento = (event, value, maskedValue) => {
      this.obs.value = value
      this.obs.texto = value
    }

    const maxHeight = () => {
      let height = screen.height;

      if (height < 800) {
        return "450px"
      } else if (height >= 800 && height < 850) {
        return "500px"
      } else if (height >= 850 && height < 850) {
        return "580px"
      } else {
        return "610px"
      }
    }

    const valid_text_input = () => {
      if (this.obs.selectedTag.value == "data") {
        return (
          <FormGroup label="Texto">
            <MonthPicker
              onChange={(e) => this.handleDateChange(e)}
              value={this.obs.select_date}
            />
          </FormGroup>
        )
      }

      if (this.obs.selectedTag.value == "number") {
        return (
          <FormGroup label="Texto">
            <IntlCurrencyInput
              className="form-control"
              onChange={hanldeRendimento}
              value={this.obs.value}
              currency="BRL"
              config={currencyConfig}
            />
          </FormGroup>
        )
      }

      if (this.obs.selectedTag.value == "boolean") {
        return (
          <FormGroup
            className="nz-horizontal-field selectFullWidth" label="Texto"
          >
            <HTMLSelect
              onChange={(e) => this.handleSelectBoolean(e.target.value)}
              value={this.obs.isBoolean}
            >
              <option value="">Selecione</option>
              <option value="false">Não</option>
              <option value="true">Sim</option>
            </HTMLSelect>
          </FormGroup>
        )
      }

      if (this.obs.selectedTag.value == "calculo") {
        let tmp_tipo = RelatorioStore.obs.tipo.toLowerCase().replace("í", "i");
        let tmp_modelo = RelatorioStore.obs.modelo.toLowerCase().replace("-", "");

        let calcOptions = []

        calcOptions = RelatorioStore.validForDate(this.obs.calcs)?.map((calc: ICalc) => {
          if (calc[tmp_tipo] == true && calc[tmp_modelo] == true) {
            return <option key={calc._id} value={calc.nome}>{calc.nome}</option>;
          }
        },
        );

        calcOptions.unshift(
          <option value="selecione">Selecione o Cálculo</option>,
        );

        return (
          <FormGroup
            className="nz-horizontal-field selectFullWidth" label="Texto"
          >
            <HTMLSelect
              onChange={e => this.handleSelectCalc(e.target.value)}
              value={this.obs.calcFilter}
            >
              {calcOptions}
            </HTMLSelect>
          </FormGroup>
        )
      }

      if (this.obs.selectedTag.value == "classificacao") {
        LookupStore.loadIcmsClassificacoes(RelatorioStore.obs.selectedEmpresa.uf)
        let classItems = LookupStore.obs.icms_classificacoes.concat(
          [{ codigo_receita: "0000", nome: "Sem classificação (itens não calculados)" }],
        );

        return (
          <FormGroup label="Texto">
            <IcmsClassificacaoSelect
              items={classItems}
              itemRenderer={renderIcmsClassificacao}
              itemPredicate={filterIcmsClassificacao}
              onItemSelect={(item: IIcmsClassificacao) => this.handleSelectClass(item)}
            >
              <Button
                text={(this.obs.icmsClassFilter && this.obs.icmsClassFilter.nome) ||
                  "Selecionar classificação"
                }
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
                className="IcmsClassificacao"
              />
            </IcmsClassificacaoSelect>
          </FormGroup>
        )
      }

      return (
        <FormGroup label="Texto">
          <InputGroup value={this.obs.texto} onChange={(e) => this.obs.texto = e.target.value} />
        </FormGroup>
      )
    }

    return (
      <>
        <div style={{ display: "flex", width: "100%" }}>
          <MDBCol md="3">
            <FormGroup className="empresaSelect" label="Filtro">
              <TagsSelect
                items={this.obs.sorted_tags}
                itemRenderer={renderTags}
                itemPredicate={filterTags}
                onItemSelect={(e: ITags) => this.handleSelectTag(e)}
                inputProps={{ placeholder: "Filtrar uma Tag" }}
              >
                <Button
                  text={selectText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </TagsSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol md="2">
            <FormGroup
              className="nz-horizontal-field selectFullWidth" label="Operação"
            >
              <HTMLSelect
                onChange={(e) => this.obs.op = e.target.value}
                value={this.obs.op}
              >
                <option value="">Selecione</option>
                <option value="==">Igual a</option>
                <option value="!=">Diferete de</option>

                <option value=">">Maior que</option>
                <option value="<">Menor que</option>

                <option value=">=">Maior igual que</option>
                <option value="<=">Menor igual que</option>

                {this.obs.selectedTag.value != "data" &&
                  <>
                    <option value="begin_with">Começa com</option>
                    <option value="end_with">Termina com</option>

                    <option value="includes">Contém</option>
                    <option value="not_includes">Não Contém</option>
                  </>
                }
              </HTMLSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol md="3">
            {valid_text_input()}
          </MDBCol>
          <MDBCol md="2">
            <MDBBtn
              style={{ marginTop: 25 }}
              className="btnDefault btnBuscarNfe"
              onClick={() => this.handleAddItem()}
            >
              Adicionar filtro
            </MDBBtn>
          </MDBCol>
        </div>

        <div></div>
        <br />

        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <TaskList ref={provided.innerRef} {...provided.droppableProps} style={{ maxHeight: maxHeight() }}>
                <Title>{"Filtros"}</Title>
                {this.state.items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TaskInformationBloco>
                          <div style={{ display: "flex", width: "100%" }}>
                            <MDBCol md="1">
                              <FormGroup label="Index">
                                <InputGroup value={index} disabled />
                              </FormGroup>
                            </MDBCol>
                            <MDBCol md="3">
                              <FormGroup label="Filtro">
                                <InputGroup value={item.name} disabled />
                              </FormGroup>
                            </MDBCol>
                            <MDBCol md="2">
                              <FormGroup label="Operação">
                                <HTMLSelect value={item.op} disabled>
                                  <option value="">Selecione</option>
                                  <option value="==">Igual a</option>
                                  <option value="!=">Diferete de</option>

                                  <option value=">">Maior que</option>
                                  <option value="<">Menor que</option>

                                  <option value=">=">Maior igual que</option>
                                  <option value="<=">Menor igual que</option>

                                  <option value="begin_with">Começa com</option>
                                  <option value="end_with">Termina com</option>

                                  <option value="includes">Contém</option>
                                  <option value="not_includes">Não Contém</option>
                                </HTMLSelect>
                              </FormGroup>
                            </MDBCol>
                            <MDBCol md="3">
                              <FormGroup label="Texto">
                                <InputGroup value={item.texto} disabled />
                              </FormGroup>
                            </MDBCol>
                            <MDBCol md="1">
                              <MDBBtn color="default" rounded size="sm" style={{ marginTop: 25 }} onClick={() => this.handleDelete(item.id)}>
                                <img src="/images/bin.png" width={20} />
                              </MDBBtn>
                            </MDBCol>
                          </div>
                        </TaskInformationBloco>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TaskList>
            )}
          </Droppable>
        </DragDropContext>

        <div style={{ marginTop: "20px" }}>
          <MDBRow>
            <Button
              intent="primary"
              onClick={() => this.handleSolicitar()}
              style={{ marginRight: "15px" }}
            >
              Solicitar Relatório
            </Button>

            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <Button
                intent="primary"
                style={{ marginRight: "15px" }}
              >
                Salvar Relatório
              </Button>

              <div>
                <FormGroup
                  label="Nome do Relatório"
                  labelFor="nome"
                >
                  <InputGroup
                    id="nome"
                    value={this.obs.nome_relatorio}
                    onChange={(e: any) => this.obs.nome_relatorio = e.target.value}
                  />
                </FormGroup>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="primary"
                    className={Classes.POPOVER_DISMISS}
                    onClick={() => this.handleSaveRelatorio()}
                  >
                    Salvar
                  </Button>
                </div>
              </div>
            </Popover>

            <Button
              onClick={() => this.handleCancel()}
            >
              Cancelar
            </Button>
          </MDBRow>
        </div>

      </>
    )
  }
}

export default RelatorioFiltro;

